module.exports = __webpack_public_path__ + "media/home-top.ae0e3261.mp4";